/* eslint-disable class-methods-use-this */
const AsyncStore = require('@react-native-async-storage/async-storage');

/**
 * Creates an instance of AsyncStorage.
 */
function AsyncStorage() {}

AsyncStorage.prototype.setItem = function(key, value) {
  // JSON.stringify({ email, password, token })
  return AsyncStore.default.setItem(key, value);
};

AsyncStorage.prototype.getItem = async function(key) {
  const result = await AsyncStore.default.getItem(key);
  const value = JSON.parse(result);
  return value;
};

AsyncStorage.prototype.removeItem = function(key) {
  AsyncStore.default.removeItem(key);
};

module.exports = AsyncStorage;
